"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Procedure to approve spending funds on an ERC20 token. If no token address is specified, it defaults to POLY
 */


var ApproveErc20 =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ApproveErc20, _Procedure_1$Procedur);

  function ApproveErc20() {
    var _this;

    _classCallCheck(this, ApproveErc20);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApproveErc20).apply(this, arguments));
    _this.type = types_1.ProcedureType.ApproveErc20;
    return _this;
  }
  /**
   * Approve spend of an ERC20 token by another wallet. The token in question defaults to POLY if no address is supplied
   *
   * Note that if the amount has already been approved, the spending approval transaction will not be added to the queue and the procedure will return
   *
   * Note that the procedure will fail if the owner's token balance is less than the amount being approved.
   * The only exception to this is when approving a POLY spend on a testnet.
   * If that is the case, an extra transaction will be submitted to request the missing amount of tokens from the faucet
   */


  _createClass(ApproveErc20, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$args, amount, spender, tokenAddress, _this$context, contractWrappers, currentWallet, ownerAddress, polyToken, token, balance, address, polyTokenAddress, isTestnet, allowance, hasEnoughAllowance;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$args = this.args, amount = _this$args.amount, spender = _this$args.spender, tokenAddress = _this$args.tokenAddress;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, currentWallet = _this$context.currentWallet;
                _context.next = 4;
                return currentWallet.address();

              case 4:
                ownerAddress = _context.sent;
                polyToken = contractWrappers.polyToken;

                if (!tokenAddress) {
                  _context.next = 18;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return contractWrappers.getERC20TokenWrapper({
                  address: tokenAddress
                });

              case 10:
                token = _context.sent;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'The supplied address does not correspond to an ERC20 token'
                });

              case 16:
                _context.next = 19;
                break;

              case 18:
                token = polyToken;

              case 19:
                _context.next = 21;
                return token.balanceOf({
                  owner: ownerAddress
                });

              case 21:
                balance = _context.sent;
                _context.next = 24;
                return token.address();

              case 24:
                address = _context.sent;
                _context.next = 27;
                return polyToken.address();

              case 27:
                polyTokenAddress = _context.sent;
                _context.next = 30;
                return contractWrappers.isTestnet();

              case 30:
                isTestnet = _context.sent;

                if (!balance.lt(amount)) {
                  _context.next = 38;
                  break;
                }

                if (!(isTestnet && address.toUpperCase() === polyTokenAddress.toUpperCase())) {
                  _context.next = 37;
                  break;
                }

                _context.next = 35;
                return this.addTransaction(contractWrappers.getPolyTokens, {
                  tag: types_1.PolyTransactionTag.GetTokens
                })({
                  amount: amount.minus(balance).decimalPlaces(0, contract_wrappers_1.BigNumber.ROUND_HALF_UP),
                  address: ownerAddress
                });

              case 35:
                _context.next = 38;
                break;

              case 37:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Not enough funds'
                });

              case 38:
                _context.next = 40;
                return token.allowance({
                  spender: spender,
                  owner: ownerAddress
                });

              case 40:
                allowance = _context.sent;
                hasEnoughAllowance = allowance.gte(amount);

                if (!hasEnoughAllowance) {
                  _context.next = 44;
                  break;
                }

                return _context.abrupt("return");

              case 44:
                _context.next = 46;
                return this.addTransaction(token.approve, {
                  tag: types_1.PolyTransactionTag.ApproveErc20
                })({
                  spender: spender,
                  value: amount
                });

              case 46:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));
    }
  }]);

  return ApproveErc20;
}(Procedure_1.Procedure);

exports.ApproveErc20 = ApproveErc20;